import { Link } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import DateFormatter from "../../utils/dateFormatterUtils";
import titleCaseString from "../../utils/titleCaseUtils";


      
const ProfileHeader = ({activeTab,details}) => {


  console.log(details);
    return ( 
           <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="user-profile-header-banner">
                  <img
                    src="/iusevolutione/assets/img/pages/profile-banner.png"
                    alt="Banner"
                    className="rounded-top"
                  />
                </div>
                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                  <div className="flex-shrink-0 mt-n5 mx-sm-0 mx-auto ">


                    


                    {
                      details?.user_profile_photo ?
                       <img
                          src={details?.user_profile_photo }
                          alt="user"
                          className="d-block h-auto ms-0 ms-sm-4  hover-zoom rounded user-profile-img"
                          width={135} height={150}
                          style={{objectFit:"cover",cursor:"pointer",maxHeight:250,minHeight:250,width:250}}
                        />
                      :
                     <Skeleton  animation="wave" sx={{ bgcolor: 'grey.200', marginLeft:3 }} variant="rounded" width={250} height={250} />
                    }
                  </div>
                  <div className="flex-grow-1 mt-3 mt-sm-5">
                    <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                      <div className="user-profile-info">

                    <h4>
                      {
                        details ?
                          titleCaseString(`${details?.first_name} ${details?.middle_name ?? ""} ${details?.last_name} ${details?.suffix_name ?? ""}`) :
                          <Skeleton animation="wave" sx={{ bgcolor: 'grey.200' }} variant="rectangle" width={350}  />
                      }
                    </h4>
                    {
                      details ?
                        <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-pen" /> {titleCaseString(details?.user_tag)}
                          </li>
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-map" /> {titleCaseString(details?.region.toUpperCase() + `,` +details?.province.toUpperCase() +` `+ details?.barangay.toUpperCase())}
                          </li>
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-calendar-alt" /> Joined {titleCaseString(DateFormatter(details.date_created, "MM DD, YYYY")?.toUpperCase())}
                          </li>
                        </ul>
                        :
                        <Skeleton animation="wave" sx={{ bgcolor: 'grey.200' }} variant="rectangle" width={375}  />
                    }

                      </div>
                      {activeTab === 'lawyers' &&
                        <Link to={"lawyer/add"} className="btn btn-primary" >
                          <span>
                            <i className="bx bx-user-plus me-sm-1" />
                            <span className="d-none d-sm-inline-block">
                              Add New Lawyer
                            </span>
                          </span>
                        </Link>
                      }


                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
     );
}
 
export default ProfileHeader;